var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { removeHashRevokeUserEmail } from '@/shared/utils/helpers';
import { translateRole, translateAccountType } from '@/shared/utils/translate';
let UsersTableRow = class UsersTableRow extends Vue {
    constructor() {
        super(...arguments);
        this.translateRole = translateRole;
        this.translateAccountType = translateAccountType;
    }
    get removeHashRevokeUserEmail() {
        return removeHashRevokeUserEmail(this.user.email);
    }
    enableUser() {
        return this.user;
    }
    disableUser() {
        return this.user;
    }
    showAccountInfo() {
        return this.user;
    }
};
__decorate([
    Prop({ default: () => { } })
], UsersTableRow.prototype, "user", void 0);
__decorate([
    Emit('enableUser')
], UsersTableRow.prototype, "enableUser", null);
__decorate([
    Emit('disableUser')
], UsersTableRow.prototype, "disableUser", null);
__decorate([
    Emit('showAccountInfo')
], UsersTableRow.prototype, "showAccountInfo", null);
UsersTableRow = __decorate([
    Component({
        name: 'UsersTableRow',
        components: {},
    })
], UsersTableRow);
export default UsersTableRow;
